import { ManagementTemplate, UserInformations } from '@quality24/design-system';
import { useStorage } from '@quality24/react-hooks';
import React, { useCallback } from 'react';
import { NavLink, Outlet } from 'react-router';
import { useFilterPersistenceStore } from '@quality24/data-containers';
import { disconnectWebsocket } from '@/inpatient-dashboard/services/websocket';
import { useAuth } from '@/inpatient-dashboard/hooks/auth/useAuth';
import { useMenu } from '@/inpatient-dashboard/contexts/menu';
import usePaginationStore from '@/inpatient-dashboard/hooks/usePaginationStore';

/**
 * <RootLayout> component.
 */
const RootLayout: React.FunctionComponent = () => {
  const { userData, loading, signOut } = useAuth();

  const { menu } = useMenu();
  const { retrieveItem } = useStorage();
  const { thumbLight, light } = userData?.hospitalConfig?.logos || {};
  const userInformations: UserInformations = {
    logo: thumbLight || light,
    email: userData?.email || '-',
    role: userData?.['custom:role'],
  };

  const handleLogout = useCallback(() => {
    signOut();
    disconnectWebsocket();
    useFilterPersistenceStore.getState().clearFilters();
    usePaginationStore.getState().reset();
  }, [signOut]);

  if (loading) return null;

  return (
    <ManagementTemplate
      menu={menu}
      menuItemAs={NavLink}
      userInformations={userInformations}
      onLogout={handleLogout}
      hideNavbar={retrieveItem('embed', 'false') === 'true'}
    >
      <Outlet />
    </ManagementTemplate>
  );
};

export default RootLayout;
